module.exports = __webpack_public_path__ + "media/images/icons/courses/9-dae8703bc7881aa3b6784ec7ae76494a.svg";